module.exports = __webpack_public_path__ + "img/logo.391ceca8.svg";